const HEIGHT = /^\d(?:_\d{1,2}){0,1}$/;

/**
 * Splits height in Feet and inches.
 * The value could be with the format [feet]_[inches],
 * where the last part (i.e "_[inches]") is optional.
 * Default inches will be zero.
 *
 * @param {String|Int} value The height with the format [feet]_[inches]
 * @returns {Object} The heigth split by property.
 */
function parseHeight(value) {
  let parts = [];
  if (HEIGHT.test(value)) {
    parts = value.split('_');
  }

  return {
    feet: parts[0] || 0,
    inches: parts[1] || 0,
  };
}

export default parseHeight;
